import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03b66392"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("新增导师")
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { key: 2 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("上传 ")
const _hoisted_7 = ["src"]
const _hoisted_8 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_upload_outlined = _resolveComponent("upload-outlined")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_EditorComponent = _resolveComponent("EditorComponent")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, { title: "导师管理" }, {
      extra: _withCtx(() => [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: $setup.addApply
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_table, {
          dataSource: _ctx.list,
          columns: $setup.columns,
          bordered: "",
          pagination: $setup.pagination,
          onChange: $setup.handleTableChange,
          style: {"margin-top":"10px"}
        }, {
          bodyCell: _withCtx(({ column, text, record }) => [
            (column.key === 'image')
              ? (_openBlock(), _createBlock(_component_a_image, {
                  key: 0,
                  src: record.image,
                  style: {"width":"50px"}
                }, null, 8, ["src"]))
              : _createCommentVNode("", true),
            (column.key === 'intro')
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  onClick: ($event: any) => ($setup.showAbout(record.intro, true))
                }, "查看", 8, _hoisted_2))
              : _createCommentVNode("", true),
            (column.key === 'action')
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_a_button, {
                    size: "small",
                    onClick: ($event: any) => ($setup.edit(record))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_a_popconfirm, {
                    title: "是否删除该导师?",
                    onConfirm: ($event: any) => ($setup.onDel(record))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        size: "small",
                        style: {"margin":"5px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "pagination", "onChange"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.visible) = $event)),
      title: _ctx.title,
      onOk: _cache[4] || (_cache[4] = ($event: any) => ($setup.onSubmit('formRef'))),
      width: "40%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          ref: "formRef",
          rules: $setup.rules,
          model: _ctx.formState,
          name: "basic",
          "label-col": { span: 3 },
          "wrapper-col": { span: 22 },
          autocomplete: "off"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              label: "导师姓名",
              name: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.name,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.name) = $event)),
                  placeholder: "请输入导师姓名"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "头衔",
              name: "position"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.position,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.position) = $event)),
                  placeholder: "请输入头衔"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "导师头像",
              name: "image"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_upload, {
                  name: "file",
                  class: "avatar-uploader",
                  headers: $setup.uploadHeaders,
                  action: $setup.uploadAction,
                  data: $setup.uploadFormData,
                  onChange: $setup.handleChange,
                  "show-upload-list": false
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(_component_a_button, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_upload_outlined),
                          _hoisted_6
                        ]),
                        _: 1
                      })
                    ]),
                    (_ctx.formState.image!== '' )
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.formState.image,
                          style: {"width":"50px","margin-top":"10px"}
                        }, null, 8, _hoisted_7))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["headers", "action", "data", "onChange"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "导师简介",
              name: "intro"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_EditorComponent, {
                  ref: "editorComponentRef",
                  content: _ctx.formState.intro
                }, null, 8, ["content"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "排序",
              name: "sort"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.formState.sort,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.sort) = $event)),
                  placeholder: "请输入排序"
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["rules", "model"])
      ]),
      _: 1
    }, 8, ["visible", "title"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.introVisible,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.introVisible) = $event)),
      title: "简介",
      footer: null,
      width: "700px"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          innerHTML: _ctx.about,
          class: "about"
        }, null, 8, _hoisted_8)
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}